export const state = () => ({
  userRoles: [],
  loading: false,
  error: null,
  pagination: {
    page: 0,
    size: 10,
    totalElements: 0,
    totalPages: 0
  }
})

export const getters = {
  userRoles: (state) => state.userRoles,
  loading: (state) => state.loading,
  error: (state) => state.error,
  pagination: (state) => state.pagination
}

export const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_USER_ROLES(state, data) {
    if (data.content) {
      state.userRoles = data.content
      state.pagination = {
        page: data.number,
        size: data.size,
        totalElements: data.totalElements,
        totalPages: data.totalPages
      }
    } else {
      state.userRoles = Array.isArray(data) ? data : []
    }
  },
  ADD_USER_ROLE(state, userRole) {
    state.userRoles.push(userRole)
  },
  REMOVE_USER_ROLE(state, { userId, roleId }) {
    state.userRoles = state.userRoles.filter(
      ur => !(ur.user?.id === userId && ur.role?.id === roleId)
    )
  }
}

export const actions = {
  async fetchUserRoles({ commit }, { userId, page = 0, size = 10, sortBy = 'roleId', direction = 'asc' } = {}) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.get(`/auth/api/user-roles/by-user/${userId}`, {
        params: { page, size, sortBy, direction }
      })
      commit('SET_USER_ROLES', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch user roles')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async assignRole({ commit }, userRoleData) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.post('/auth/api/user-roles', userRoleData)
      commit('ADD_USER_ROLE', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to assign role')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async removeRole({ commit }, { userId, roleId }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      await this.$axios.delete('/auth/api/user-roles', {
        data: { userId, roleId }
      })
      commit('REMOVE_USER_ROLE', { userId, roleId })
      return true
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to remove role')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

